import PropTypes from "prop-types"

const p = Object.assign({}, PropTypes)
p.step = function (props, propName, componentName) {
  let p = props[propName]
  if (!p.Id || !p.Name )
    return new Error(
      'Not a "Step": Invalid prop `' + propName + '` supplied to' +
      ' `' + componentName + '`. Validation failed.'
    );
}

export default p



// WEBPACK FOOTER //
// ./src/PropTypes.js